import Swiper from "swiper/swiper-bundle";
import GLightbox from "glightbox";

export default {
  init() {
    const slideshow = new Swiper(".slideshow.swiper", {
      loop: true,
      navigation: {
        nextEl: "",
        prevEl: "",
        clickable: true,
      },
      autoplay: {
        delay: 4000,
      },
      speed: 3000,
    });

    const slideshowmobile = new Swiper(".slideshow-mobile.swiper", {
      loop: true,
      navigation: {
        nextEl: "",
        prevEl: "",
        clickable: true,
      },
      autoplay: {
        delay: 4000,
      },
      speed: 3000,
    });

    const testimonial = new Swiper(".testimonial-gallery .swiper", {
      slidesPerView: 1,
      breakpoints: {
        992: {
          slidesPerView: 3,
        },
        768: {
          slidesPerView: 1,
        },
      },
      slidesPerGroup: 1,
      spaceBetween: 50,
      navigation: {
        nextEl: ".testimonial-button-next",
        prevEl: ".testimonial-button-prev",
        clickable: true,
      },
      pagination: {
        el: ".swiper-pagination-home",
        clickable: true,
      },
    });

    const consignment = new Swiper(".consignment-gallery .swiper", {
      slidesPerView: 1,
      breakpoints: {
        992: {
          slidesPerView: 4,
        },
      },
      slidesPerGroup: 1,
      spaceBetween: 50,
      pagination: {
        el: ".swiper-pagination-consignment",
        clickable: true,
      },
    });

    const article = new Swiper(".article-gallery .swiper", {
      slidesPerView: 1,
      breakpoints: {
        992: {
          slidesPerView: 3,
          loop: false,
        },
        768: {
          slidesPerView: 2,
          loop: false,
        },
      },
      slidesPerGroup: 1,
      spaceBetween: 50,
      loop: true,
      pagination: {
        el: ".swiper-pagination-article",
        clickable: true,
      },
    });

    const lightbox = GLightbox({
      selector: ".glightbox",
    });

    // Call the function to set up event listeners after all elements are loaded
    this.setupEventListeners();
  },
  finalize() { },

  setupEventListeners() {
    // Setup event listeners for tab navigation
    const tablinks = document.querySelectorAll(".tablinks");
    tablinks.forEach((tablink) => {
      tablink.addEventListener("click", (event) => {
        const channelName = tablink.getAttribute("data-channel");
        this.openChannel(event, channelName);
      });
    });
  },

  openChannel(evt, channelName) {
    const tabcontent = document.querySelectorAll(".tabcontent");
    tabcontent.forEach((content) => {
      content.style.display = "none";
    });
    const tablinks = document.querySelectorAll(".tablinks");
    tablinks.forEach((link) => {
      link.classList.remove("channel-active");
    });
    document.getElementById(channelName).style.display = "block";
    evt.currentTarget.classList.add("channel-active");
  }
};
